export const isValidJSON = (str: string) => {
  if (typeof str !== 'string') return false;
  try {
    const parsed = JSON.parse(str);
    // Optional: ensure it's an object or array, not just a number, string, etc.
    return typeof parsed === 'object' && parsed !== null;
  } catch (e) {
    return false;
  }
};
